/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import AccountName from "../../../../components/_utils/AccountCreationComponents/AccountName";
import ContactDetails from "../../../../components/_utils/AccountCreationComponents/ContactDetails";
import {
  EditUser,
  getSpecificUser,
} from "../../../../redux/features/Settings/Management/Users";

import Validation from "../../../../utils/validation";
import UserGrade from "../../../../components/Settings/User/UserDetailsInput/UserGrade";
import { getEntities } from "../../../../redux/features/Settings/Management/entities";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import LoginDetails from "../../../../components/Settings/User/UserDetailsInput/LoginDetails";
import ICONS from "../../../../assets/Icons";
import CommonLayout from "../../../../components/_utils/CommonLayout";

const UserEditContact = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [customErrors, setCustomErrors] = useState({});
  const [emailValidation, setEmailValidation] = useState(false);
  const [nextButtonEnabled, setNextButtonEnabled] = useState(false);
  const [openEditContactPop, setOpenEditContactPop] = useState(false);

  const { editUserLoading } = useSelector((state) => state.users);
  const [accountNameValidation] = useState(true);
  const [contactNumberValidation, setContactNumberValidation] = useState(false);

  const [payload, setPayload] = useState({
    contact_no: "",
    email_id: "",
    account_name: "",
    legalName: "",
    grade: "",
    user_id: "",
    alias: "",
    password: "",
  });

  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const [originalPayload, setOriginalPayload] = useState(null);

  const [gradeOption, setGradeOption] = useState([]);
  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const queryParams = {
          entity_id: JSON.parse(sessionStorage.getItem("response"))?.entity
            ?.entity_id,
        };

        const entityRes = await dispatch(getEntities(queryParams));

        if (
          entityRes?.payload?.status &&
          entityRes?.payload?.entities?.length >
            GlobalConfiguration.lengthCheckZero
        ) {
          setGradeOption(
            entityRes.payload.entities[GlobalConfiguration.lengthCheckZero]
              .grades || [],
          );
        }
      } catch (err) {
        console.error("Failed to load entity grades:", err);
      }
    };

    fetchEntityData();
  }, [dispatch]);

  useEffect(() => {
    if (!payload || !originalPayload) {
      setHasUnsavedChanges(false);
      return;
    }

    const isDirty =
      payload.account_name.trim() !== originalPayload.account_name.trim() ||
      payload.contact_no.trim() !== originalPayload.contact_no.trim() ||
      payload.email_id.trim() !== originalPayload.email_id.trim() ||
      payload.grade.trim() !== originalPayload.grade.trim() ||
      payload.alias.trim() !== originalPayload.alias.trim();

    setHasUnsavedChanges(isDirty);
  }, [payload, originalPayload]);

  useEffect(() => {
    const contact = (payload.contact_no || "").trim();
    const email = (payload.email_id || "").trim();

    const contactValid =
      contact === "" ||
      (contact.length === GlobalConfiguration.owneraccountnormalLength &&
        Validation.allowedContactNum(contact));

    const emailValid = email === "" || Validation.emailRegex.test(email);

    setContactNumberValidation(contactValid);
    setEmailValidation(emailValid);
  }, [payload.contact_no, payload.email_id]);

  const [selectedRadioValue, setSelectedRadioValue] = useState("customname");

  const { specificUserData } = useSelector((state) => state.users);
  const userName =
    specificUserData?.employees?.[GlobalConfiguration.lengthCheckZero]
      ?.user_name ||
    specificUserData?.employees?.[GlobalConfiguration.lengthCheckZero]
      ?.identifier ||
    "";

  useEffect(() => {
    const fetchContactData = async () => {
      let response = await dispatch(getSpecificUser(id));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchContactData();
  }, [dispatch, id, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (!allowedValue(name, value)) return;

    validateAndRecordError(name, value);

    setPayload((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (
      name === "account_name" &&
      value.trim().toLowerCase() === payload.legalName.trim().toLowerCase()
    ) {
      setSelectedRadioValue("legalname");
    }

    if (
      name === "account_name" &&
      value.trim().length > GlobalConfiguration.lengthCheckZero &&
      value.trim().toLowerCase() !== payload.legalName.trim().toLowerCase()
    ) {
      setSelectedRadioValue("customname");
    }
  };
  const nameRegex = /^[A-Za-z0-9 ]*$/;

  const allowedValue = (name, value) => {
    if (name === "account_name") return nameRegex.test(value);
    if (name === "contact_no") return Validation.allowedContactNum(value);
    if (name === "email_id") return Validation.allowedEmail(value);
    if (name === "alias") return allowedAlias(value);
    return true;
  };

  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };
    if (name === "email_id")
      errors = Validation.validateEmail(name, value, errors);
    if (name === "contact_no")
      errors = Validation.validateContactNum(name, value, errors);
    if (name === "alias") errors = validateAlias(name, value, errors);

    setCustomErrors(errors);
  };

  const handleUpdateLegalName = (value) => {
    const panName = payload.legalName || "";

    setPayload((prev) => {
      if (value === "legalname") {
        return {
          ...prev,
          account_name: panName,
        };
      }

      if (value === "customname") {
        const keepCurrent =
          prev.account_name &&
          prev.account_name.trim().length >
            GlobalConfiguration.lengthCheckZero &&
          prev.account_name.trim().toLowerCase() !==
            panName.trim().toLowerCase();

        return {
          ...prev,
          account_name: keepCurrent
            ? prev.account_name
            : originalPayload?.account_name || prev.account_name,
        };
      }

      return prev;
    });
  };

  const handleDivBtn = (type) => {
    setSelectedRadioValue(type);
    handleUpdateLegalName(type);
  };

  const handleAttemptLeave = () => {
    if (hasUnsavedChanges) {
      setOpenEditContactPop(true);
    } else {
      navigate(GlobalConfiguration.navigate_back);
    }
  };

  const handleConfirmLeave = () => {
    setOpenEditContactPop(false);
    navigate(GlobalConfiguration.navigate_back);
  };

  const handleRadioBtn = (e) => {
    handleDivBtn(e.target.value);
  };

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      stepperText: "Contact details",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextIsEnabled: nextButtonEnabled,
      nextHoverOption: "black",
      nextIsLoading: editUserLoading,
      nextLoaderNeeded: true,
    },
  ];
  const aliasRegex = /^[a-zA-Z0-9_-]+$/;

  const allowedAlias = (value) => {
    if (value === "") return true;
    return aliasRegex.test(value);
  };

  const validateAlias = (name, value, errors) => {
    if (!aliasRegex.test(value)) {
      errors[name] =
        "Only letters, numbers, underscore (_) and hyphen (-) are allowed";
    } else {
      delete errors[name];
    }
    return errors;
  };

  useEffect(() => {
    if (!payload || !originalPayload) {
      setNextButtonEnabled(false);
      return;
    }

    const allFieldsFilled =
      payload.account_name.trim() !== "" &&
      payload.contact_no.trim() !== "" &&
      payload.email_id.trim() !== "" &&
      payload.grade.trim() !== "" &&
      payload.alias.trim() !== "";

    if (!allFieldsFilled) {
      setNextButtonEnabled(false);
      return;
    }

    const hasAnyChange =
      payload.account_name.trim() !== originalPayload.account_name.trim() ||
      payload.contact_no.trim() !== originalPayload.contact_no.trim() ||
      payload.email_id.trim() !== originalPayload.email_id.trim() ||
      payload.grade.trim() !== originalPayload.grade.trim() ||
      payload.alias.trim() !== originalPayload.alias.trim();

    if (!hasAnyChange) {
      setNextButtonEnabled(false);
      return;
    }

    const isNameValid =
      payload.account_name.trim().length >=
      GlobalConfiguration.accountminLength;
    const isContactValid =
      payload.contact_no.trim().length ===
        GlobalConfiguration.owneraccountnormalLength &&
      Validation.allowedContactNum(payload.contact_no.trim());
    const isEmailValid = Validation.emailRegex.test(
      payload.email_id.trim().toLowerCase(),
    );
    const isGradeValid = payload.grade.trim() !== "";
    const isAliasValid =
      payload.alias.trim().length > GlobalConfiguration.lengthCheckTwo &&
      allowedAlias(payload.alias.trim());

    setNextButtonEnabled(
      isNameValid &&
        isContactValid &&
        isEmailValid &&
        isGradeValid &&
        isAliasValid,
    );
  }, [payload, originalPayload]);

  useEffect(() => {
    if (specificUserData?.employees?.[GlobalConfiguration.lengthCheckZero]) {
      const user =
        specificUserData.employees[GlobalConfiguration.lengthCheckZero];

      const fullName = [user.first_name, user.last_name]
        .filter(Boolean)
        .join(" ");

      const panName = specificUserData?.pan_details?.full_name || "";

      const initialPayload = {
        account_name: fullName,
        fullName,
        legalName: panName,
        contact_no: user.mob_no ? String(user.mob_no) : "",
        email_id: user.email_id || "",
        grade: user.grade || "",
        user_id: user.identifier || user.user_name || "",
        alias: user.alias_name || "",
        password: "",
      };

      setPayload(initialPayload);
      setOriginalPayload(initialPayload);
      setSelectedRadioValue(
        fullName.toLowerCase() === panName.toLowerCase()
          ? "legalname"
          : "customname",
      );
    }
  }, [specificUserData]);

  const handleUpdateContact = async () => {
    const nameParts = payload.account_name.trim().split(" ");
    const first_name = nameParts[GlobalConfiguration.lengthCheckZero] || "";
    const last_name = nameParts
      .slice(GlobalConfiguration.lengthCheckOne)
      .join(" ");

    try {
      const resultAction = await dispatch(
        EditUser({
          id,
          first_name,
          last_name,
          mob_no: payload.contact_no,
          email: payload.email_id?.toLowerCase(),
          grade: payload.grade,
          alias_name: payload.alias,
        }),
      );

      if (EditUser.fulfilled.match(resultAction)) {
        navigate(
          `/settings/user_view_all/user_detail_page/contact_details_success/${id}`,
        );
      }

      if (EditUser.rejected.match(resultAction)) {
        const apiErrors = resultAction.payload?.errors;

        let formattedMessage = "Something went wrong while updating the user.";

        if (apiErrors && typeof apiErrors === "object") {
          formattedMessage = Object.entries(apiErrors)
            .map(([field, messages]) => {
              return messages.join(", ");
            })
            .join(" ");
        }

        navigate(
          `/settings/user_view_all/user_detail_page/contact_details_error/${id}`,
          {
            state: {
              errorMessage: formattedMessage,
              id: id,
            },
          },
        );
      }
    } catch (err) {
      console.error("Unexpected error:", err);
    }
  };

  return (
    <>
      <div className=" bg-primary-bg flex overflow-y-hidden flex-col h-full-height">
        <div className="h-navbar-breadcrumb-height hidden Qmd:block"></div>
        <div
          className="max-w-tab-width-normal w-full flex flex-col justify-start items-center mx-auto my-margin-base Qsmd:h-stepper-moble-height"
          style={{
            overflow: !nextButtonEnabled && openEditContactPop ? "hidden" : "",
          }}
        >
          {openEditContactPop && (
            <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
              <SmallPopup
                headerTitle={"Confirm leaving this page?"}
                headerFontWeight="semibold"
                headerFontColor="text-primary"
                textSize="font-md"
                subtext="Leaving this page will not save the changes made."
                btnOneText="Stay"
                btnOneBtnType="button"
                btnOneEnabledBgColor="transparent"
                btnOneHandleFunction={() => setOpenEditContactPop(false)}
                btnOneOutLineColor="var(--text-primary)"
                btnOneEnabledTextColor="var(--text-primary)"
                btnOneIsDisabled={false}
                btnOneHoverOption="white"
                btnTwoText="Leave"
                btnTwoBtnType="button"
                btnTwoHandleFunction={handleConfirmLeave}
                btnTwoEnabledBgColor="var(--negative-act)"
                btnTwoEnabledTextColor="var(--text-primary)"
                btnTwoIsDisabled={false}
                btnTwoHoverOption="black"
              />
            </div>
          )}
          <div className="min-h-stepper-height Qsmd:relative h-auto flex justify-center items-end bottom-bottom-base Qsmd:flex fixed Qmd:top-top-base left-left-base w-width-full z-z-index-header">
            <PrimaryStepper
              activeStep={GlobalConfiguration.lengthCheckZero}
              handleForwardAction={handleUpdateContact}
              handleBackwardAction={handleAttemptLeave}
              dataArray={dataArray}
            />
          </div>
          <div className="bg-primary-nav mt-margin-base fixed top-top-base left-left-base w-full z-z-index-header">
            <div className="h-navbar-height bg-primary-nav fixed top-top-base w-width-full flex items-center z-z-index-header shadow-box-shadow-bottom">
              <div
                className="w-icon-sm h-icon-sm m-margin-md cursor-pointer"
                onClick={handleAttemptLeave}
              >
                <SVGComponent
                  url={ICONS?.ARROW_LEFT_WHITE}
                  height="var(--icon-sm)"
                  width="var(--icon-sm)"
                  color="var(--text-primary)"
                  alt="arrow left"
                />
              </div>
              <div className="py-padding-sm">
                <p className="text-text-primary text-font-md">Users</p>
                <p className="text-text-secondary text-font-xs">
                  Contact details
                </p>
              </div>
            </div>
          </div>

          <div className="h-navbar-height block Qmd:hidden"></div>
        </div>

        <div className="w-full flex-1 min-h-0 overflow-y-auto px-padding-md Qlg:px-padding-base pt-padding-md pb-[var(--stepper-moble-height)]">
          <div className="max-w-tab-width-normal mx-auto">
            <CommonLayout>
              <div className="flex flex-col relative w-full rounded-border-radius-md mb-margin-md">
                <AccountName
                  handleChange={handleChange}
                  accountName={payload.account_name}
                  legalName={payload.legalName}
                  userName={userName}
                  selectedRadioValue={selectedRadioValue}
                  handleDivBtn={handleDivBtn}
                  handleRadioBtn={handleRadioBtn}
                  accountNameValidation={accountNameValidation}
                  placeHolder="Account name"
                />
                <UserGrade
                  userPayload={payload}
                  setUserPayload={setPayload}
                  gradeOption={gradeOption}
                />
              </div>
              <div className="flex flex-col relative rounded-border-radius-md w-full mb-margin-md">
                <ContactDetails
                  handleChange={handleChange}
                  contactNumber={payload.contact_no}
                  emailId={payload.email_id}
                  contactNumberValidation={contactNumberValidation}
                  emailValidation={emailValidation}
                />
                <LoginDetails
                  userPayload={payload}
                  handleChange={handleChange}
                  showUserId={false}
                  showPassword={false}
                />
              </div>
            </CommonLayout>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserEditContact;
